import {Container, Tab, Tabs} from "react-bootstrap";
import React, {useContext, useState} from "react";
import {UsacmContext} from "../App";
import {useLocation} from "react-router-dom";
import {PageHeader} from "../menu/PageHeader";
import {CourseSettingsCourses} from "./CourseSettingsCourses";
import {CourseSettingsApprove} from "./CourseSettingsApprove";
import {CourseSettingsCoupons} from "./CourseSettingsCoupons";
import {CourseSettingsEmail} from "./CourseSettingsEmail";
import {CourseSettingsReports} from "./CourseSettingsReports";
import {hasPermission} from "../api/UserApi";
import {
  CONF_LABEL_KEY_COURSE,
  PERMISSION_CONF_ADMIN,
  PERMISSION_COURSE_ADMIN,
  PERMISSION_STAFF
} from "../constants";
import {getConfLabel, makePlural, titleCase} from "../utils/usacmUtils";

export function CourseSettingsTabs() {
  const context = useContext(UsacmContext);
  const [conf,] = context.conference;
  const courseLabel = titleCase(getConfLabel(conf, CONF_LABEL_KEY_COURSE));
  // Purchases are approved, coupons and emails edited and the reports run by course admins only (not instructors)
  const canApprove = hasPermission(PERMISSION_STAFF) || hasPermission(PERMISSION_CONF_ADMIN) ||
    hasPermission(PERMISSION_COURSE_ADMIN);
  // ?tab=approve opens a tab directly (the Review Needed email links to it)
  const {search} = useLocation();
  const requestedTab = new URLSearchParams(search).get('tab');
  const [activeTab, setActiveTab] = useState(
    canApprove && ['approve', 'coupons', 'email', 'reports'].includes(requestedTab) ? requestedTab : 'courses');
  // Bumped to remount the courses tab, which takes it from a course's editor back to the course list
  const [coursesKey, setCoursesKey] = useState(0);

  // Clicking the courses tab while it is already selected goes back to the course list
  function selectTab(tab) {
    if (tab === 'courses' && activeTab === 'courses') {
      setCoursesKey(coursesKey + 1);
    }
    setActiveTab(tab);
  }

  return (
    <div>
      <PageHeader pageTitle={courseLabel + ' Settings'}/>
      <Container fluid className="usacm-container-wide">
        <Tabs
          activeKey={activeTab}
          onSelect={selectTab}
          id="course-settings-tabs"
          className="mb-3"
          mountOnEnter={true}
          unmountOnExit={true}
        >
          <Tab eventKey="courses" title={makePlural(courseLabel)}>
            <CourseSettingsCourses key={coursesKey}/>
          </Tab>
          {canApprove &&
            <Tab eventKey="approve" title="Approve">
              <CourseSettingsApprove/>
            </Tab>
          }
          {canApprove &&
            <Tab eventKey="coupons" title="Coupons">
              <CourseSettingsCoupons/>
            </Tab>
          }
          {canApprove &&
            <Tab eventKey="email" title="Email">
              <CourseSettingsEmail/>
            </Tab>
          }
          {canApprove &&
            <Tab eventKey="reports" title="Reports">
              <CourseSettingsReports/>
            </Tab>
          }
        </Tabs>
      </Container>
    </div>
  );
}
